import { pathJoin } from 'src/reducers/routing/utils'

export const createLocationCreateRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
})
